import { Box, SxProps, Typography } from "@mui/material";

interface Props {
  text: string;
  highlightWords: string[];
  sx?: SxProps;
}

export default function HighlightText({ text, highlightWords, sx }: Props) {
  const regex = new RegExp(`(${highlightWords.join("|")})`, "gi");
  const lines = text.split(/\r\n|\n/);

  return (
    <Box sx={sx}>
      {lines.map((line, index) => {
        const parts = line.split(regex);
        return (
          <Typography sx={styles.inherit} key={index}>
            {parts.map((part: string, i: number) =>
              highlightWords.some((str: string) => str.toLowerCase() === part.toLowerCase())
                ? <Typography component={"span"} sx={{ ...styles.inherit, color: "red"}} key={i}>{part}</Typography>
                : <Typography component={"span"} sx={styles.inherit} key={i}>{part}</Typography>
            )}
          </Typography>
        )
      })}
    </Box>
  )
}

const styles = {
  inherit: {
    fontSize: "inherit",
    fontWeight: "inherit"
  }
}
